import {
  DeleteSpendingPolicyDocument,
  SpendingPoliciesListPageDocument,
} from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useMutation } from 'modules/core/hooks/useMutation'

export const useDeleteSpendingPolicy = () => {
  const { company } = useCurrentSession()

  const [deleteSpendingPolicy, { loading }] = useMutation(DeleteSpendingPolicyDocument, {
    extractorFn: (data) => data.financeMutations.deleteFinanceSpendingPolicySpendingPolicy,
    refetchQueries: [
      { query: SpendingPoliciesListPageDocument, variables: { companyId: company.id.toString() } },
    ],
  })

  return {
    loading,
    deleteSpendingPolicy: (id: string) => deleteSpendingPolicy({ variables: { id } }),
  }
}
